import { create } from 'zustand'
import type { ProfileBuilderCandidate } from '@/services/profileBuilder'

export interface ManualOnboardingEntry {
  displayName: string
}

export type OnboardingHandoff =
  | { kind: 'candidate'; candidate: ProfileBuilderCandidate }
  | { kind: 'manual'; manual: ManualOnboardingEntry }

interface OnboardingCandidateState {
  candidate: ProfileBuilderCandidate | null
  manual: ManualOnboardingEntry | null
  setCandidate: (candidate: ProfileBuilderCandidate | null) => void
  setManual: (manual: ManualOnboardingEntry | null) => void
  consume: () => OnboardingHandoff | null
}

export const useOnboardingCandidate = create<OnboardingCandidateState>()(
  (set, get) => ({
    candidate: null,
    manual: null,
    setCandidate: (candidate) => set({ candidate, manual: null }),
    setManual: (manual) => set({ manual, candidate: null }),
    consume: () => {
      const { candidate, manual } = get()
      set({ candidate: null, manual: null })
      if (candidate) return { kind: 'candidate', candidate }
      if (manual) return { kind: 'manual', manual }
      return null
    },
  }),
)
